import { VisuallyHidden } from 'radix-ui'
import z from 'zod'

import { getTranslate } from '@/legacy-src/utilities/i18n'

import { StyleLimits } from '@/src/domains/recommended-therapist/constants'
import { getStyleMatchLabel } from '@/src/domains/recommended-therapist/utils/getStyleMatchLabel'

const ValueSchema = z.number().int().min(0).max(100)

export interface StyleMatchProps {
  value: number
  ['aria-labelledby']?: string
}

export const RecommendedTherapistStyleMatch = ({ value, 'aria-labelledby': ariaLabelledby }: StyleMatchProps) => {
  const { t } = getTranslate()

  const { success, error, data } = ValueSchema.safeParse(value)

  if (!success) {
    console.warn(`StyleMatch: value ${value} is out of bounds (0-100)`, error)
    return null
  }

  const isPoor = value < StyleLimits.OK

  const isOk = value >= StyleLimits.OK && value < StyleLimits.GREAT

  const label = getStyleMatchLabel(value, t)

  return (
    <>
      <VisuallyHidden.VisuallyHidden>
        <meter min={0} max={100} value={data} aria-labelledby={ariaLabelledby}>
          {label}
        </meter>
      </VisuallyHidden.VisuallyHidden>
      <div className={`relative mt-[65px] flex w-full`}>
        <div className={`h-3 w-1/4 rounded-md bg-pink-500`} />
        <div className={`h-3 w-1/4 rounded-md bg-blue-500`} />
        <div className={`h-3 w-1/4 rounded-md bg-secondary`} />
        <div className={`h-3 w-1/4 rounded-md bg-secondary`} />

        <div className="absolute -top-1/2 -ml-3" style={{ left: `${data}%` }}>
          <div className={`flex h-6 w-6 items-center justify-center rounded-full bg-primary`}>
            <div className={`h-[14px] w-[14px] rounded-full bg-white`} />
          </div>
          <div
            className={`absolute ${isPoor ? 'left-[80px]' : isOk ? '' : '-right-[90px]'} -top-[45px] flex max-w-[164px] -translate-x-1/2 transform whitespace-nowrap rounded-md bg-yellow-500 px-2 py-1 text-xs font-bold text-petrol-500`}
          >
            <div
              className={`absolute -bottom-[3px] ${
                isPoor ? 'left-0 translate-x-1/2' : isOk ? 'left-1/2' : 'right-0 -translate-x-1/2'
              } -bottom-[3px] h-4 w-4 rotate-45 transform bg-yellow-500`}
            ></div>
            <span className="relative z-10 w-[175px] whitespace-nowrap text-center">{label}</span>
          </div>
        </div>
      </div>
    </>
  )
}
